import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "~/components/ui/dialog";
import { useAuth } from "~/contexts/auth-context";
import { Button } from "~/components/button";
import { Text } from "~/components/text";

export function SignoutModal() {
  const { t } = useTranslation(["general", "components"]);
  const { signOut } = useAuth();

  return (
    <Dialog>
      <DialogTrigger asChild>
        <div className="w-full p-2 text-left items-center text-secondary-600 hover:bg-secondary-100 flex flex-row font-medium text-sm">
          <Text as="span">{t("components:header.logOut")}</Text>
        </div>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader className="space-y-1 py-2">
          <DialogTitle>{t("components:header.logOutMessage.one")}</DialogTitle>
          <DialogDescription>
            {t("components:header.logOutMessage.two")}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <DialogClose asChild>
            <Button variant="link" label={t("components:header.goBack")} />
          </DialogClose>
          <DialogClose asChild>
            <Button
              variant="primary"
              onClick={signOut}
              label={t("components:header.logOut")}
            />
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
